class FAQGroups extends HTMLElement {
  constructor() {
    super();

    this.filters = Array.from(this.querySelectorAll('[data-faq-groups-filter]'));
    this.listGroup = this.querySelector('[data-faq-groups-list]');
    this.filterAll = this.querySelector('[data-faq-groups-filter-all]');

    if (!this.filters.length || !this.listGroup || !this.filterAll) return;

    this.filters.forEach((filter) => {
      filter.addEventListener('click', this.handleFilterClick.bind(this));
    });

    this.resetAll();
  }

  handleFilterClick(e) {
    const target = e.target;
    // If "All" is clicked
    if (target === this.filterAll) {
      if (target.classList.contains('active')) return;

      this.filters.forEach((filter) => {
        filter.classList.remove('button--active');
      });

      target.classList.add('button--active');
    } else {
      this.resetAll();
      this.filters.forEach((filter) => {
        filter.classList.remove('button--active');
      });
      this.filterAll.classList.remove('button--active');
      target.classList.toggle('button--active');
    }

    this.showFAQGroup(Number(target.dataset.index));
  }

  showFAQGroup(index) {
    if (index === 0) {
      this.resetAll();
    } else {
      this.listGroup.classList.remove('all');
      const indexList = index - 1;

      this.listGroup.children[indexList].classList.toggle('!flex');

      let hasToShow = false;
      // Check if any FAQ group is showing
      for (const li of this.listGroup.children) {
        if (li.classList.contains('!flex')) {
          hasToShow = true;
        }
      }
      // Make all active and show all FAQ groups
      if (!hasToShow) {
        this.resetAll();
      }
    }
  }

  resetAll() {
    this.listGroup.classList.add('all');
    this.filterAll.classList.add('button--active');

    for (const group of this.listGroup.children) {
      group.classList.remove('!flex');
    }
  }
}

if (!customElements.get('faq-groups')) {
  customElements.define('faq-groups', FAQGroups);
}
